import React, { Component } from "react";
import Card from "../components/Card";

export default class Hobbies extends Component {
  render() {
    return (
      <React.Fragment>
        <Card id="Hobbies" className="content" headerText="Hobbies">
          <ul>
            <li>
              <p>
                Fitness and exercise – playing football and going to the gym.
              </p>
            </li>
            <li>
              <p>
                Tech - I like to involve technology as often as possible in my
                daily life, from learning to DJ to following tutorials/ courses
                on my laptop.{" "}
              </p>
            </li>
            <li>
              <p>
                Watching football – attending Aston Villa games with my family
                and friends.
              </p>
            </li>
            <li>
              <p>
                Learning Spanish - on daily basis I use a phone application to
                learn spanish
              </p>
            </li>
          </ul>
        </Card>
      </React.Fragment>
    );
  }
}
